import React, { useEffect, useState } from 'react'

const CourseFilterSection = ({handleFilter, courses = []}) => {

    const [criteres, setCriteres] = useState({level: "", type: "", hours: ""});
    const [countLevel, setCountLevel] = useState({beginner: 1, intermediate: 1, advanced: 2});

    useEffect(() => {

        let beginner = courses.filter((course) => course.level.toLowerCase() == "beginner").length;
        let intermediate = courses.filter((course) => course.level.toLowerCase() == "intermediate").length;
        let advanced = courses.filter((course) => course.level.toLowerCase() == "advanced").length;

        setCountLevel({beginner: beginner, intermediate: intermediate, advanced: advanced});

        return () => {
            
        }
    }, []);

    const HandleChange = (e) => {
        let temp = {};
        temp[e.target.name] = e.target.value;

        setCriteres({...criteres, ...temp});
        handleFilter({...criteres, ...temp});
    }

    return (
        <div className="uk-width-1-4@m">

            <div className="sidebar-filter" uk-sticky="top:20 ;offset: 90; bottom: true ; media : @m">

                <button className="btn-sidebar-filter" uk-toggle="target: .sidebar-filter; cls: sidebar-filter-visible">Filtrer </button>

                <div className="sidebar-filter-contents">


                    <h4> Filtrer par </h4>

                    <ul className="sidebar-filter-list" uk-accordion="multiple: true">

                        <li className="uk-open">
                            <a className="uk-accordion-title" href="#"> Niveau de compétences </a>
                            <div className="uk-accordion-content">
                                <div className="uk-form-controls">
                                    <label>
                                        <input value="beginner" className="uk-radio" type="radio" name="level" onChange={HandleChange.bind(this)} />
                                        <span className="test"> Débutant <span> ({countLevel.beginner}) </span> </span>
                                    </label>
                                    <label>
                                        <input value="intermediate" className="uk-radio" type="radio" name="level" onChange={HandleChange.bind(this)} />
                                        <span className="test"> Intermédiaire<span> ({countLevel.intermediate}) </span></span>
                                    </label>
                                    <label>
                                        <input value="advanced" className="uk-radio" type="radio" name="level" onChange={HandleChange.bind(this)} />
                                        <span className="test"> Avancé <span> ({countLevel.advanced}) </span></span>
                                    </label>
                                    <label>
                                        <input value="all" className="uk-radio" type="radio" name="level" onChange={HandleChange.bind(this)} defaultChecked />
                                        <span className="test"> Tous <span> ({courses.length}) </span></span>
                                    </label>
                                </div>
                            </div>
                        </li>

                        <li className="uk-open">
                            <a className="uk-accordion-title" href="#"> Type de cours </a>
                            <div className="uk-accordion-content">
                                <div className="uk-form-controls">
                                    <label>
                                        <input className="uk-radio" type="radio" name="type" onChange={HandleChange.bind(this)} />
                                        <span className="test"> Gratuits (42) </span>
                                    </label>
                                    <label>
                                        <input className="uk-radio" type="radio" name="type" onChange={HandleChange.bind(this)} />
                                        <span className="test"> Payants </span>
                                    </label>
                                </div>
                            </div>
                        </li>

                        <li className="uk-open">
                            <a className="uk-accordion-title" href="#"> Durée </a>
                            <div className="uk-accordion-content">
                                <div className="uk-form-controls">
                                    <label>
                                        <input className="uk-radio" type="radio" name="hours" onChange={HandleChange.bind(this)} />
                                        <span className="test"> +5 Heures (23) </span>
                                    </label>
                                    <label>
                                        <input className="uk-radio" type="radio" name="hours" onChange={HandleChange.bind(this)} />
                                        <span className="test"> +10 Heures (12)</span>
                                    </label>
                                    <label>
                                        <input className="uk-radio" type="radio" name="hours" onChange={HandleChange.bind(this)} />
                                        <span className="test"> +20 Heures (5)</span>
                                    </label>
                                    <label>
                                        <input className="uk-radio" type="radio" name="hours" onChange={HandleChange.bind(this)} />
                                        <span className="test"> +30 Heures (2)</span>
                                    </label>
                                </div>
                            </div>
                        </li>


                    </ul>



                </div>

            </div>

        </div>

    )
}

export default CourseFilterSection
